import { enableProdMode, enableProfiling } from '@angular/core';
import { Acl } from '@df/core/service/acl';
import { fastBootstrapApplication } from 'ngx-fastboot';

if (Acl.isProdMode()) {
    enableProdMode();
} else {
    // Turn on profiling *before* bootstrapping your application
    // in order to capture all of the code run on start-up.
    enableProfiling();
}

fastBootstrapApplication(() => import(/* webpackChunkName: "app" */ './app/app.component').then(m => m.AppComponent), {
    providers: [() => import(/* webpackChunkName: "app-config" */ './app/app.config').then(m => m.appConfig.providers)]
}).catch(error => {
    console.error(error);
});
